








import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
import { createFocusTrap, Options, FocusTrap } from 'focus-trap';
import { setFocus } from '@/app/accessibility/accessibility-utils';
import { waitToLoad, cancelToken, CancelToken, cancel, reset } from '@/app/shared/utils'

@Component
export default class WrapperModalComponent extends Vue {
  @Prop({
    default: false
  })
  public shows: boolean;

  @Prop({
    default: true
  })
  public backdrop: boolean;

  @Prop({
    default: false
  })
  public fullWidth: boolean;

  @Prop({
    default: false
  })
  public fullHeight: boolean;

  @Prop({
    default: false
  })
  public headerMargin: boolean;

  @Prop({
    default: false
  })
  public storeModal: boolean;

  @Prop({
    default: null
  })
  public focusElement: string|null;

  @Prop({
    default: false
  })
  public preventClose: boolean;

  private focusTrap: FocusTrap | null = null;
  private focusTrapCancel: CancelToken = cancelToken()

  public closeModal() {
    this.deactivateFocusTrap();
    if (!this.preventClose)
      this.$emit('closeModal', 'true');
  }

  @Watch('shows')
  public async isModalShown(newValue: boolean) {
    if (newValue) {
      const success = await this.trapFocus();
      if (success) {
        document.body.style.overflow = 'hidden';
      }
    } else {
      document.body.style.overflow = 'initial';
      this.deactivateFocusTrap();
    }
  }

  private async trapFocus() {

    reset(this.focusTrapCancel)

    const trapSelector = '.modal-wrapper.shows'
    const result = await waitToLoad(() => !!$(trapSelector).length, this.focusTrapCancel)
    if (!result.success) {
      return false
    }

    const options: Options = {
      clickOutsideDeactivates: true,
    };

    if (this.focusElement !== null) {
      options.initialFocus = this.focusElement;
      setFocus(this.focusElement)
    }
    options.fallbackFocus = $('.modal-wrapper-content')[0]
    this.focusTrap = createFocusTrap(trapSelector, options);
    this.focusTrap.activate();

    return true;
  }

  private deactivateFocusTrap(): void {
    cancel(this.focusTrapCancel)
    if (this.focusTrap === null) {
      return;
    }

    this.focusTrap.deactivate();
    this.focusTrap = null
  }

  private beforeDestroy() {
    cancel(this.focusTrapCancel)
  }
}
